import React, { useState } from 'react';
import AuthLayout from '../../components/layout/AuthLayout.jsx';
import { useGetAdminTicketsQuery } from '../../api/tickets.js';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import TicketFilter from '../../components/misc/tickets/TicketFilter.jsx';
import ThreeDotsLoader from '../../components/misc/ThreeDotsLoader.jsx';
import TicketsFiltersButtons from '../../components/misc/tickets/TicketsFiltersButtons.jsx';
import TicketsItem from '../../components/misc/tickets/TicketsItem.jsx';

const AdminTickets = () => {
    const [showFilter, setShowFilter] = useState(false);
    const [isAscending, setIsAscending] = useState(false);
    const [filters, setFilters] = useState({ status: null, type: null, date: null, user: null });

    const { data: adminTickets, isLoading: adminTicketsLoading } = useGetAdminTicketsQuery({
        type: filters.type || null,
        status: filters.status || null,
        user: filters.user || null
    });

    const adminTicketsList = adminTickets?.response?.tickets || [];

    const filteredTickets = adminTicketsList.filter((ticket) => {
        if (!filters.date) return true;
        return dayjs(ticket.created_at).isSame(dayjs(filters.date), 'day');
    });

    const sortedTickets = [...filteredTickets].sort((a, b) =>
        isAscending ? new Date(a.created_at) - new Date(b.created_at) : new Date(b.created_at) - new Date(a.created_at)
    );

    return (
        <AuthLayout title='Tickets Management' backRoute='/dashboard'>
            {adminTicketsLoading ? (
                <ThreeDotsLoader className='mt-6' />
            ) : (
                <div className='max-w-3xl w-full mx-auto mt-6 px-8'>
                    {showFilter && (
                        <TicketFilter onFilterChange={setFilters} filters={filters} setShowFilter={setShowFilter} />
                    )}
                    <div className='flex justify-between items-center'>
                        <div className='text-xl font-bold text-theme1-primary2'>Received Tickets</div>
                        <TicketsFiltersButtons
                            showFilter={showFilter}
                            setShowFilter={setShowFilter}
                            isAscending={isAscending}
                            setIsAscending={setIsAscending}
                        />
                    </div>
                    <div className='flex flex-col gap-6 mt-6 mb-6'>
                        {sortedTickets.map((ticket) => (
                            <Link to={`/tickets/${ticket.id}`} key={ticket.id}>
                                <TicketsItem ticket={ticket} adminTicket />
                            </Link>
                        ))}
                    </div>
                </div>
            )}
        </AuthLayout>
    );
};

export default AdminTickets;
